'use client'
interface OfferPriceProps {
  oldPrice?: number
  newPrice: number
  copyTop?: string
  copyBottom?: string
}

export const OfferPrice = (props: OfferPriceProps) => {
  const { oldPrice, newPrice, copyBottom, copyTop } = props

  return (
    <div className="mb-5 flex flex-col gap-2 text-center">
      <p className="text-body-lg">{copyTop}</p>
      <div className="flex justify-center gap-1 text-bodi-black-text">
        {oldPrice && (
          <span className="text-heading-2 text-bodi-gray-disabled line-through">${oldPrice}</span>
        )}
        <div>
          <span className="text-heading-1 leading-none">${newPrice}</span>
          <span className="text-body-md font-medium text-bodi-gray-medium">/mo</span>
        </div>
      </div>
      <p className="text-body-sm text-bodi-gray-dark">{copyBottom}</p>
    </div>
  )
}
